import React, { useState, useEffect } from 'react';

type Callback<T> = (debouncedValue: T) => void;

const useDebounce = <T, >(
  cb: Callback<T>, delay: number,
): (value: T) => void => {
  const [data, setData] = useState<T>();

  useEffect(() => {
    const timeoutRef = setTimeout(() => {
      if (data !== undefined) {
        cb(data);
        setData(undefined);
      }
    }, delay);
    return () => {
      clearTimeout(timeoutRef);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, delay]);

  return (value: T) => {
    setData(value);
  };
};

export default useDebounce;
